
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta } from "/app/pages/help.vue?macro=true";
import { default as homeATfYOZM_NGzagjGhIsvcT2b9_cFGO0yRVLFd_45gK_451EkMeta } from "/app/pages/home.vue?macro=true";
import { default as newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta } from "/app/pages/news.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as alertsXKvVgNh9KtPV7EEuCglt8Lkwn_454nMiTaDJbIHcpCmXYMeta } from "/app/pages/alerts.vue?macro=true";
import { default as dooziesaM6kR977Ap6Yrdzf_45JHLjUj0z1bpHl5966P0uqYanhQMeta } from "/app/pages/doozies.vue?macro=true";
import { default as pitchescpB9enIQLdnnnwjKmTAbi8z1nY_fwIPu1bWYl517Ey4Meta } from "/app/pages/pitches.vue?macro=true";
import { default as meetingsLJN3vjgdK1cewsD8KSWsvA5ibG7JSPSWtz5RWRa3TGkMeta } from "/app/pages/meetings.vue?macro=true";
import { default as settingsDGUPgOPonJUdwz8k5B4RVSmTRVCcKBNUebfgnD29s5kMeta } from "/app/pages/settings.vue?macro=true";
import { default as timelinehkB_45fJsDYjaY1t55ot_45qNg27wQsOJil82T5oYZxj6Z8Meta } from "/app/pages/timeline.vue?macro=true";
import { default as _91id_93bKXYM8A_nlWE6zVk_r3tae1nITNGSbtnNzzSNj3D4kwMeta } from "/app/pages/chat/[id].vue?macro=true";
import { default as editorialSvu_45XhfkV_45gdMXqozX1sDrJOUc9UpNS0S8nJrzMkSoYMeta } from "/app/pages/editorial.vue?macro=true";
import { default as indexvhfhWVotO_456VvDOq_45cYkZMmeSIieYf1jIKy2UpS3yT0Meta } from "/app/pages/auth/index.vue?macro=true";
import { default as indexBN_PyuODBq4eSxq0GppjpQJwY3SuQ1tH7SjTZibfHMYMeta } from "/app/pages/chat/index.vue?macro=true";
import { default as pitch_45deckzin1o23oDKdGaM03xugP9Lyi5rcDz9fkhi1SFHrplWgMeta } from "/app/pages/pitch-deck.vue?macro=true";
import { default as rolesHTqyDYe8xL_b8yiG0PrIVZ5BGAkYZdub49gDHw8auJUMeta } from "/app/pages/admin/roles.vue?macro=true";
import { default as usagel2shDkzKxmQTu9QGQ7RDofqbjvHTuywmnkZ5T54FZOMMeta } from "/app/pages/admin/usage.vue?macro=true";
import { default as users0dvwj0GYikGWaRqGKQojuF0hl_wUB0ZSFJtbA1vtME8Meta } from "/app/pages/admin/users.vue?macro=true";
import { default as signinr_rYGcquUCtCe6UaCroPiKQxhVVecQ8xFrQzqubNzVsMeta } from "/app/pages/auth/signin.vue?macro=true";
import { default as signupsTWjhAgrrNIHjZDxwXTWWZ6X6mjwk7GNfKEQ1VBvxXYMeta } from "/app/pages/auth/signup.vue?macro=true";
import { default as company_45hubN9qIDeGK2WkHyZYWIQZyfSH60XjEOHG_45aHxcF0B96yoMeta } from "/app/pages/company-hub.vue?macro=true";
import { default as doozy_45watchFHfQhcEgBd0UhAcGtLEzVnNIwjhrtMC_451mCeNqlQZ6EMeta } from "/app/pages/doozy-watch.vue?macro=true";
import { default as judge_45watchGCUZTAOQxoDmGpvS1vkMlnc_45CrBcwv4SjX6VXX1lD8kMeta } from "/app/pages/judge-watch.vue?macro=true";
import { default as _91id_93vIaNwIAMXQaAZxO2cB7SMOIsbP_456fcw3XF2kyVkc0c8Meta } from "/app/pages/models/[id].vue?macro=true";
import { default as troubleYg2Rxs3Qk2uN3UXAA2s_453n_45LzEF0LlBIwgBFL613dngMeta } from "/app/pages/auth/trouble.vue?macro=true";
import { default as judge_45review_bao0MK91uUpPQRPKkDNoA98xEiTw29DwYrtyVxPr68Meta } from "/app/pages/judge-review.vue?macro=true";
import { default as indexom8v1QhqzUn182vzD5EXqGUpbf2m6m1e4xxIeV7LSKAMeta } from "/app/pages/models/index.vue?macro=true";
import { default as sourcesk4v5e2JCtLbfTC9cqou_T__45KnggI376khNIeo3grl2UMeta } from "/app/pages/admin/sources.vue?macro=true";
import { default as design_45systemuotsUbrM2eGyLGzNVxAceQNmgtDt6AWcy9GUdgNaKzQMeta } from "/app/pages/design-system.vue?macro=true";
import { default as label_45mappingRapjneufMS8OPH5vTLCxJTrHp31wkyHrcc62X7GQFDQMeta } from "/app/pages/label-mapping.vue?macro=true";
import { default as opportunitiesNSvhHTy8QsowD0g_45Aap2qSegnYsgJ6jQGrD3Z4eYobwMeta } from "/app/pages/opportunities.vue?macro=true";
import { default as indexP_T7wPh_aodPu5ikFWVi4tb5ggCS9bYgYggORuX_45lvAMeta } from "/app/pages/reports/index.vue?macro=true";
import { default as feedbackdG0TKvFHPktZ_JWzDlT_45TgipVmqCS5AGGK9_tqnLx98Meta } from "/app/pages/admin/feedback.vue?macro=true";
import { default as _91name_93ZY_45Fy8fanKcbFvPqnIY9iiUSLnZLciXnn_ixHjyzmXcMeta } from "/app/pages/reports/[name].vue?macro=true";
import { default as reset_45passwordiWFFQc4mqHAplbYzhpvNKouyr6Qp9Bvu_45FM1ScN8_pgMeta } from "/app/pages/reset-password.vue?macro=true";
import { default as companiesILq8RvQ4APOhwgxiHzljhqVTxKddmquXesjSRvJcU6UMeta } from "/app/pages/admin/companies.vue?macro=true";
import { default as llm_45auditl9AoPhcViAq91GuLWDFRWFfiC_45SQaOhsYxDReth4cMoMeta } from "/app/pages/admin/llm-audit.vue?macro=true";
import { default as llm_45usageHxZ_QmnfYXqQNtdcTCwcAYKgSqKu45x_Elw8Ss2XrFAMeta } from "/app/pages/admin/llm-usage.vue?macro=true";
import { default as rag_45debugrSMNCclnTBONXJMIzITCQyNlaW1a_JsX90ikm_45e37Q4Meta } from "/app/pages/admin/rag-debug.vue?macro=true";
import { default as client_45settingsCSkE7hSm_eZxlh27OfZWkgZsheRz4fV1QlbazDQ6dD4Meta } from "/app/pages/client-settings.vue?macro=true";
import { default as indexsAUGwTvEAtg6KtmCn_2SigoMVMv7dQs4gkd6w3q6NpAMeta } from "/app/pages/companies/index.vue?macro=true";
import { default as admin9720CrWNPKMppfcO4c198eVFP5Vr56GKVEkEBlWVMpUMeta } from "/app/pages/dashboard/admin.vue?macro=true";
import { default as index_45F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_45gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as _91id_93Y3LC_45YSATl4bOgMy7k5nFqnH3zmlSJaGzEQxqiWC8MsMeta } from "/app/pages/onboarding/[id].vue?macro=true";
import { default as news_45agentVp4sPeyTVsBAhDiGPohlz4hP6gAfxBDmxzihtum_45LBYMeta } from "/app/pages/admin/news-agent.vue?macro=true";
import { default as portfoliosoYI_45W8E7U8Cuqghue_45_4534blVKEq2CP45xQPbEa5Rnb4Meta } from "/app/pages/admin/portfolios.vue?macro=true";
import { default as _91name_93vJI0Kt9PlXzeEZOGk87HPUWzTn3hFFRYgXOq3Ii8yk0Meta } from "/app/pages/companies/[name].vue?macro=true";
import { default as indexUVBClvupsRCX2G6PsxxLFj_Cptg_0DzxwuByyCSKk1MMeta } from "/app/pages/onboarding/index.vue?macro=true";
import { default as index8TI5VPNxnbaVNHA2P_FViQEEPa295mCgbMoXtJQ6IHYMeta } from "/app/pages/v5-reports/index.vue?macro=true";
import { default as trip_45ledgerMmyZByywUjwnSkRgX6dglKFa7U33yHmrSalPFt0oIWgMeta } from "/app/pages/admin/trip-ledger.vue?macro=true";
import { default as risks_45exportvs5_45YphXJjq1t00FbvxzEXYA7ymf7tUIJQJKxjoukqIMeta } from "/app/pages/admin/risks-export.vue?macro=true";
import { default as questions4h1ryYQGlFophdD3aPfwUZsmC07qZQtYXWtsRqtgdJUMeta } from "/app/pages/admin/v3/questions.vue?macro=true";
import { default as one_45time_45codeTzg_45ppg5qqISjTiBJtWPPsnWbkzvMiCa6YgeTRptkDsMeta } from "/app/pages/auth/one-time-code.vue?macro=true";
import { default as _91run_id_93_chT4c8DfFw1XhkbyMxc_5_458OemFZBj1RyZLHZOSu9gMeta } from "/app/pages/impact-v5/[run_id].vue?macro=true";
import { default as portfolio_45calendarqsIBIIipEDj8Z6Su7Uit4rj4NRLMTfPdkhma_rh60AoMeta } from "/app/pages/portfolio-calendar.vue?macro=true";
import { default as connectionscRsy2L_MPuK6bjz3vrXwUfzgs3KbfsyZnilsOIk8ezcMeta } from "/app/pages/account/connections.vue?macro=true";
import { default as alert_45scoringvgbNSda5Lfk6OEXzLN_45zZiMCyt3utJqLhZF0GmNQVjkMeta } from "/app/pages/admin/alert-scoring.vue?macro=true";
import { default as model_45linkageRnQ_45PJahCerhGbwCSZul7A8F11ACaLlKpsYbHIAB5WkMeta } from "/app/pages/admin/model-linkage.vue?macro=true";
import { default as indexDD8y7aHVzrjx4FgTwBeNFGJVLGC_455PVniIV6jqplLlIMeta } from "/app/pages/admin/prompts/index.vue?macro=true";
import { default as report_45layouttJhwxWHxC3vfy79sedAMb_45gSpeLaSkir__Rhz_45asZNsMeta } from "/app/pages/admin/report-layout.vue?macro=true";
import { default as index7edFw7cYsRnUFGCTh0Iscjen_45oGJmY4yo7NSOwPslooMeta } from "/app/pages/admin/sectors/index.vue?macro=true";
import { default as signal_45ledgerjyIOQ1JRJ6mOWpdkW62srh6d84JfGCTEcV7qI0hM0DEMeta } from "/app/pages/admin/signal-ledger.vue?macro=true";
import { default as site_45feedbackzN8NHXEM5SRS_hSGfqByDoB_gqxEBC2yRcW0INZ6kg8Meta } from "/app/pages/admin/site-feedback.vue?macro=true";
import { default as password_45resetATJ8ZVSzp7f_8LiLOoeMAdhVO8CXTJ_45LyT6LiDSHJHMMeta } from "/app/pages/auth/password-reset.vue?macro=true";
import { default as risk_45questionssdfH78NYRXQC__45KL5gFYWNidvzSg4USXoG_45R7t6x3P8Meta } from "/app/pages/labs/risk-questions.vue?macro=true";
import { default as portfolio_45readinessSt5Kmz6z0ZJS2hzNRsQiqjBBRjaEMAzkp4DicIfe17AMeta } from "/app/pages/portfolio-readiness.vue?macro=true";
import { default as _91run_id_93Ukasu8F1EsxwNwZZweUfXDs6k6FfkWWTnagIK9hltBkMeta } from "/app/pages/v5-reports/[run_id].vue?macro=true";
import { default as ai_45connectionsyF_H6t6TDEhugfl8StFMuGdbn8FeGbPv3lOWsMzczSYMeta } from "/app/pages/admin/ai-connections.vue?macro=true";
import { default as alert_45feedbackm5wl9PpPCDHR71cqQm_wrwzxxKkgBPG1If7v3NpYKXYMeta } from "/app/pages/admin/alert-feedback.vue?macro=true";
import { default as company_45exportPlVceq8N_45QOR_45PXH0iRZzsN1bj7loeKFWR7CQRPWbrwMeta } from "/app/pages/admin/company-export.vue?macro=true";
import { default as generic_45eventsi8cLoLcmesNNo1rW2nx1MhU39PPDIJPZUgfnkXO9gT0Meta } from "/app/pages/admin/generic-events.vue?macro=true";
import { default as impact_45reportszsERTOgMu6KteQIyjBAKywENjaCKk7FaAk50HmYWCZsMeta } from "/app/pages/admin/impact-reports.vue?macro=true";
import { default as model_45research_nkmPT_45_45vVgJPmxWGQ9ZCad9k2l8QD2CSVEE4pxaKh0Meta } from "/app/pages/admin/model-research.vue?macro=true";
import { default as prompts_45exportir8B3ELt1I3Insy_Ljs8zjiyhFSx3W9uyqg4I68iBUAMeta } from "/app/pages/admin/prompts-export.vue?macro=true";
import { default as _91name_93rbCy1DDpXde12fZnjUeDP6MOob0tlxi8s0p31GIPHSAMeta } from "/app/pages/admin/prompts/[name].vue?macro=true";
import { default as risk_45questionsJ44PVv_45S1CK20CgW1J1_454p5DxIzvlUSTwPNjNQpi_6QMeta } from "/app/pages/admin/risk-questions.vue?macro=true";
import { default as forget_45passwordU1EBUr9B3T5U9rohSt5IVYHqlEIyTZsxbrASAJO89HsMeta } from "/app/pages/auth/forget-password.vue?macro=true";
import { default as notifications4jNzK0tDbzKa01Fye_bbxcMSXoSoIA9RZ3X53aPI8SUMeta } from "/app/pages/account/notifications.vue?macro=true";
import { default as email_45templatescyXikG4h5m4i6Ohp_c0w6g4CelqYR5u3MUYMXf3Y_45EYMeta } from "/app/pages/admin/email-templates.vue?macro=true";
import { default as forecast_45modelsQOPTaEIMYyNugpqXAATATK2PbVRDR7jxDg2gbQuJ_4568Meta } from "/app/pages/admin/forecast-models.vue?macro=true";
import { default as forecast_45runneryGyTCUPy9DKrQPncR3x_pdSCSIsnjV8Y7BPSvuuS9CoMeta } from "/app/pages/admin/forecast-runner.vue?macro=true";
import { default as portfolio_45radarfqglZdUeWpAKYXmuPFxF9633dcv0fadjg2Z_84t9CsoMeta } from "/app/pages/admin/portfolio-radar.vue?macro=true";
import { default as provider_45statusB74Urrnd67UzN3K0sgy9aCSlyB3gb7Ezibn8a1K9p1sMeta } from "/app/pages/admin/provider-status.vue?macro=true";
import { default as sector_45transferMv0iaoSgPgWG1fl2mclB4RgvM53a6YwGsNqzAy_456B6YMeta } from "/app/pages/admin/sector-transfer.vue?macro=true";
import { default as _91level_936khU4m9A3MsrxDPIu35U8LvSy0eb2hUlC7yZSg4Q7BgMeta } from "/app/pages/admin/sectors/[level].vue?macro=true";
import { default as indexNa07TSVuSg8sgrV5mchxNBxtrptvfXv8I0I2mOj4_KYMeta } from "/app/pages/sector-insights/index.vue?macro=true";
import { default as _91sessionId_93_45lbIXX5dXze6QNMUYI18tWhjlNXEJbAP2KIGDPJNyvEMeta } from "/app/pages/pitch-pack/[sessionId].vue?macro=true";
import { default as series_45model_45runsix61anbnG4Zhj3b3BCygYenCdh1nXwu8JPJ4N8VjcJQMeta } from "/app/pages/admin/series-model-runs.vue?macro=true";
import { default as operations_45supply_45chainyRFup7roO7CNFkGJSIEJZI9EzEe8R4lv65Ki_15Ks_45MMeta } from "/app/pages/operations-supply-chain.vue?macro=true";
import { default as exposure_45questionsXOQJWjiwVZJn2djl9Kkb10rMPI0Je1ykJcZ5sOvBIYUMeta } from "/app/pages/admin/exposure-questions.vue?macro=true";
import { default as report_45definitionsycnehw0UoAC157_mVzLy8JgVhvLgYZW01nRtTVGVuw4Meta } from "/app/pages/admin/report-definitions.vue?macro=true";
import { default as _91run_id_93XlOaO_457VdYdvj_gYKiY6fVqP_Spu9if0vY0Lr9lMfrAMeta } from "/app/pages/sector-insights/[run_id].vue?macro=true";
import { default as _91id_93C9rNvvGBunOAMoy0gfaDNQq9hU8tRTxgw5tZ1DBIrfMMeta } from "/app/pages/admin/pipeline-queue/[id].vue?macro=true";
import { default as indexQ16ox29lIVTORbwzOTeu91v03Xd_45Htk4_45I95Bao_45AcUMeta } from "/app/pages/admin/pipeline-queue/index.vue?macro=true";
import { default as indexZQ_45_45rJBlzMCse_3MhTLaa0RGzf8Z0sFo8igVn_oQh_0Meta } from "/app/pages/company-intelligence/index.vue?macro=true";
import { default as recenteLwUzhcbQ3PFav_V6TAY_gAIYDpIbkcLTf4y6kQJJaQMeta } from "/app/pages/admin/pipeline-queue/recent.vue?macro=true";
import { default as _91name_93uOfTsGXlk9Kr1B_457v3Wp33pJE9G0huznG6MJ6H6Qlj0Meta } from "/app/pages/company-intelligence/[name].vue?macro=true";
import { default as _91sector_profile_id_93y5aBgLAmen6VIEZ8GaKPUjcWkMYAu6hyGEjMs9IGSnkMeta } from "/app/pages/sector-insights/profile/[sector_profile_id].vue?macro=true";
export default [
  {
    name: "help",
    path: "/help",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: { ...(homeATfYOZM_NGzagjGhIsvcT2b9_cFGO0yRVLFd_45gK_451EkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/home.vue")
  },
  {
    name: "news",
    path: "/news",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/news.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "alerts",
    path: "/alerts",
    meta: { ...(alertsXKvVgNh9KtPV7EEuCglt8Lkwn_454nMiTaDJbIHcpCmXYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/alerts.vue")
  },
  {
    name: "doozies",
    path: "/doozies",
    component: () => import("/app/pages/doozies.vue")
  },
  {
    name: "pitches",
    path: "/pitches",
    meta: { ...(pitchescpB9enIQLdnnnwjKmTAbi8z1nY_fwIPu1bWYl517Ey4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/pitches.vue")
  },
  {
    name: "meetings",
    path: "/meetings",
    meta: { ...(meetingsLJN3vjgdK1cewsD8KSWsvA5ibG7JSPSWtz5RWRa3TGkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/meetings.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/settings.vue")
  },
  {
    name: "timeline",
    path: "/timeline",
    meta: { ...(timelinehkB_45fJsDYjaY1t55ot_45qNg27wQsOJil82T5oYZxj6Z8Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/timeline.vue")
  },
  {
    name: "chat-id",
    path: "/chat/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/chat/[id].vue")
  },
  {
    name: "editorial",
    path: "/editorial",
    meta: { ...(editorialSvu_45XhfkV_45gdMXqozX1sDrJOUc9UpNS0S8nJrzMkSoYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/editorial.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/app/pages/auth/index.vue")
  },
  {
    name: "chat",
    path: "/chat",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/chat/index.vue")
  },
  {
    name: "pitch-deck",
    path: "/pitch-deck",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/pitch-deck.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/roles.vue")
  },
  {
    name: "admin-usage",
    path: "/admin/usage",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/usage.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/users.vue")
  },
  {
    name: "auth-signin",
    path: "/auth/signin",
    component: () => import("/app/pages/auth/signin.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    component: () => import("/app/pages/auth/signup.vue")
  },
  {
    name: "company-hub",
    path: "/company-hub",
    meta: company_45hubN9qIDeGK2WkHyZYWIQZyfSH60XjEOHG_45aHxcF0B96yoMeta || {},
    component: () => import("/app/pages/company-hub.vue")
  },
  {
    name: "doozy-watch",
    path: "/doozy-watch",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/doozy-watch.vue")
  },
  {
    name: "judge-watch",
    path: "/judge-watch",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/judge-watch.vue")
  },
  {
    name: "models-id",
    path: "/models/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/models/[id].vue")
  },
  {
    name: "auth-trouble",
    path: "/auth/trouble",
    component: () => import("/app/pages/auth/trouble.vue")
  },
  {
    name: "judge-review",
    path: "/judge-review",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/judge-review.vue")
  },
  {
    name: "models",
    path: "/models",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/models/index.vue")
  },
  {
    name: "admin-sources",
    path: "/admin/sources",
    component: () => import("/app/pages/admin/sources.vue")
  },
  {
    name: "design-system",
    path: "/design-system",
    component: () => import("/app/pages/design-system.vue")
  },
  {
    name: "label-mapping",
    path: "/label-mapping",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/label-mapping.vue")
  },
  {
    name: "opportunities",
    path: "/opportunities",
    meta: { ...(opportunitiesNSvhHTy8QsowD0g_45Aap2qSegnYsgJ6jQGrD3Z4eYobwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/opportunities.vue")
  },
  {
    name: "reports",
    path: "/reports",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/reports/index.vue")
  },
  {
    name: "admin-feedback",
    path: "/admin/feedback",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/feedback.vue")
  },
  {
    name: "reports-name",
    path: "/reports/:name()",
    component: () => import("/app/pages/reports/[name].vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/app/pages/reset-password.vue")
  },
  {
    name: "admin-companies",
    path: "/admin/companies",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/companies.vue")
  },
  {
    name: "admin-llm-audit",
    path: "/admin/llm-audit",
    component: () => import("/app/pages/admin/llm-audit.vue")
  },
  {
    name: "admin-llm-usage",
    path: "/admin/llm-usage",
    component: () => import("/app/pages/admin/llm-usage.vue")
  },
  {
    name: "admin-rag-debug",
    path: "/admin/rag-debug",
    component: () => import("/app/pages/admin/rag-debug.vue")
  },
  {
    name: "client-settings",
    path: "/client-settings",
    component: () => import("/app/pages/client-settings.vue")
  },
  {
    name: "companies",
    path: "/companies",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/companies/index.vue")
  },
  {
    name: "dashboard-admin",
    path: "/dashboard/admin",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/dashboard/admin.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "onboarding-id",
    path: "/onboarding/:id()",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/onboarding/[id].vue")
  },
  {
    name: "admin-news-agent",
    path: "/admin/news-agent",
    component: () => import("/app/pages/admin/news-agent.vue")
  },
  {
    name: "admin-portfolios",
    path: "/admin/portfolios",
    component: () => import("/app/pages/admin/portfolios.vue")
  },
  {
    name: "companies-name",
    path: "/companies/:name()",
    component: () => import("/app/pages/companies/[name].vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/onboarding/index.vue")
  },
  {
    name: "v5-reports",
    path: "/v5-reports",
    meta: { ...(index8TI5VPNxnbaVNHA2P_FViQEEPa295mCgbMoXtJQ6IHYMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/v5-reports/index.vue")
  },
  {
    name: "admin-trip-ledger",
    path: "/admin/trip-ledger",
    component: () => import("/app/pages/admin/trip-ledger.vue")
  },
  {
    name: "admin-risks-export",
    path: "/admin/risks-export",
    component: () => import("/app/pages/admin/risks-export.vue")
  },
  {
    name: "admin-v3-questions",
    path: "/admin/v3/questions",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/v3/questions.vue")
  },
  {
    name: "auth-one-time-code",
    path: "/auth/one-time-code",
    component: () => import("/app/pages/auth/one-time-code.vue")
  },
  {
    name: "impact-v5-run_id",
    path: "/impact-v5/:run_id()",
    meta: { ...(_91run_id_93_chT4c8DfFw1XhkbyMxc_5_458OemFZBj1RyZLHZOSu9gMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/impact-v5/[run_id].vue")
  },
  {
    name: "portfolio-calendar",
    path: "/portfolio-calendar",
    component: () => import("/app/pages/portfolio-calendar.vue")
  },
  {
    name: "account-connections",
    path: "/account/connections",
    component: () => import("/app/pages/account/connections.vue")
  },
  {
    name: "admin-alert-scoring",
    path: "/admin/alert-scoring",
    component: () => import("/app/pages/admin/alert-scoring.vue")
  },
  {
    name: "admin-model-linkage",
    path: "/admin/model-linkage",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/model-linkage.vue")
  },
  {
    name: "admin-prompts",
    path: "/admin/prompts",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/prompts/index.vue")
  },
  {
    name: "admin-report-layout",
    path: "/admin/report-layout",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/report-layout.vue")
  },
  {
    name: "admin-sectors",
    path: "/admin/sectors",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/sectors/index.vue")
  },
  {
    name: "admin-signal-ledger",
    path: "/admin/signal-ledger",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/signal-ledger.vue")
  },
  {
    name: "admin-site-feedback",
    path: "/admin/site-feedback",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/site-feedback.vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password-reset",
    component: () => import("/app/pages/auth/password-reset.vue")
  },
  {
    name: "labs-risk-questions",
    path: "/labs/risk-questions",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/labs/risk-questions.vue")
  },
  {
    name: "portfolio-readiness",
    path: "/portfolio-readiness",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/portfolio-readiness.vue")
  },
  {
    name: "v5-reports-run_id",
    path: "/v5-reports/:run_id()",
    meta: { ...(_91run_id_93Ukasu8F1EsxwNwZZweUfXDs6k6FfkWWTnagIK9hltBkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/v5-reports/[run_id].vue")
  },
  {
    name: "admin-ai-connections",
    path: "/admin/ai-connections",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/ai-connections.vue")
  },
  {
    name: "admin-alert-feedback",
    path: "/admin/alert-feedback",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/alert-feedback.vue")
  },
  {
    name: "admin-company-export",
    path: "/admin/company-export",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/company-export.vue")
  },
  {
    name: "admin-generic-events",
    path: "/admin/generic-events",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/generic-events.vue")
  },
  {
    name: "admin-impact-reports",
    path: "/admin/impact-reports",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/impact-reports.vue")
  },
  {
    name: "admin-model-research",
    path: "/admin/model-research",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/model-research.vue")
  },
  {
    name: "admin-prompts-export",
    path: "/admin/prompts-export",
    component: () => import("/app/pages/admin/prompts-export.vue")
  },
  {
    name: "admin-prompts-name",
    path: "/admin/prompts/:name()",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/prompts/[name].vue")
  },
  {
    name: "admin-risk-questions",
    path: "/admin/risk-questions",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/risk-questions.vue")
  },
  {
    name: "auth-forget-password",
    path: "/auth/forget-password",
    component: () => import("/app/pages/auth/forget-password.vue")
  },
  {
    name: "account-notifications",
    path: "/account/notifications",
    component: () => import("/app/pages/account/notifications.vue")
  },
  {
    name: "admin-email-templates",
    path: "/admin/email-templates",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/email-templates.vue")
  },
  {
    name: "admin-forecast-models",
    path: "/admin/forecast-models",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/forecast-models.vue")
  },
  {
    name: "admin-forecast-runner",
    path: "/admin/forecast-runner",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/forecast-runner.vue")
  },
  {
    name: "admin-portfolio-radar",
    path: "/admin/portfolio-radar",
    component: () => import("/app/pages/admin/portfolio-radar.vue")
  },
  {
    name: "admin-provider-status",
    path: "/admin/provider-status",
    meta: provider_45statusB74Urrnd67UzN3K0sgy9aCSlyB3gb7Ezibn8a1K9p1sMeta || {},
    component: () => import("/app/pages/admin/provider-status.vue")
  },
  {
    name: "admin-sector-transfer",
    path: "/admin/sector-transfer",
    component: () => import("/app/pages/admin/sector-transfer.vue")
  },
  {
    name: "admin-sectors-level",
    path: "/admin/sectors/:level()",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/sectors/[level].vue")
  },
  {
    name: "sector-insights",
    path: "/sector-insights",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/sector-insights/index.vue")
  },
  {
    name: "pitch-pack-sessionId",
    path: "/pitch-pack/:sessionId()",
    meta: { ...(_91sessionId_93_45lbIXX5dXze6QNMUYI18tWhjlNXEJbAP2KIGDPJNyvEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/pitch-pack/[sessionId].vue")
  },
  {
    name: "admin-series-model-runs",
    path: "/admin/series-model-runs",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/series-model-runs.vue")
  },
  {
    name: "operations-supply-chain",
    path: "/operations-supply-chain",
    component: () => import("/app/pages/operations-supply-chain.vue")
  },
  {
    name: "admin-exposure-questions",
    path: "/admin/exposure-questions",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/exposure-questions.vue")
  },
  {
    name: "admin-report-definitions",
    path: "/admin/report-definitions",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/admin/report-definitions.vue")
  },
  {
    name: "sector-insights-run_id",
    path: "/sector-insights/:run_id()",
    meta: { ...(_91run_id_93XlOaO_457VdYdvj_gYKiY6fVqP_Spu9if0vY0Lr9lMfrAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/sector-insights/[run_id].vue")
  },
  {
    name: "admin-pipeline-queue-id",
    path: "/admin/pipeline-queue/:id()",
    component: () => import("/app/pages/admin/pipeline-queue/[id].vue")
  },
  {
    name: "admin-pipeline-queue",
    path: "/admin/pipeline-queue",
    component: () => import("/app/pages/admin/pipeline-queue/index.vue")
  },
  {
    name: "company-intelligence",
    path: "/company-intelligence",
    component: () => import("/app/pages/company-intelligence/index.vue")
  },
  {
    name: "admin-pipeline-queue-recent",
    path: "/admin/pipeline-queue/recent",
    component: () => import("/app/pages/admin/pipeline-queue/recent.vue")
  },
  {
    name: "company-intelligence-name",
    path: "/company-intelligence/:name()",
    meta: { ...(_91name_93uOfTsGXlk9Kr1B_457v3Wp33pJE9G0huznG6MJ6H6Qlj0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/company-intelligence/[name].vue")
  },
  {
    name: "sector-insights-profile-sector_profile_id",
    path: "/sector-insights/profile/:sector_profile_id()",
    meta: { ...(_91sector_profile_id_93y5aBgLAmen6VIEZ8GaKPUjcWkMYAu6hyGEjMs9IGSnkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/sector-insights/profile/[sector_profile_id].vue")
  }
]